import * as React from 'react';
import { clsx } from 'clsx';
import { LINK_CLASSNAME_MAP, LINK_TOOLTIP_TEXT_MAP } from './linkMaps';
import * as styles from './styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
export function MessengerLink(_ref) {
  var url = _ref.url,
    type = _ref.type,
    onClick = _ref.onClick;
  var typeClassName = LINK_CLASSNAME_MAP[type];
  var tooltipText = LINK_TOOLTIP_TEXT_MAP[type];
  return /*#__PURE__*/_jsx("a", {
    className: clsx(styles['messenger-link'], styles[typeClassName]),
    href: url,
    target: "_blank",
    rel: "noreferrer",
    onClick: onClick,
    children: /*#__PURE__*/_jsx("span", {
      className: styles['tooltip'],
      children: tooltipText
    })
  });
}